<div class="app-input-container" [formGroup]="group">
    <div class="app-input-label-row">
        <label class="app-input-label" *ngIf="label" [for]="id">
            <span *ngIf="getRequired()" class="required-field"
                [class.error]="getInvalid()">*</span>
            {{ label }}
        </label>

        <button type="button" tabindex="1000" *ngIf="button !== ''"
            class="app-input-label-link"
            (click)="onButtonClicked($event)">{{button}}</button>
    </div>

    <div class="app-input-entry-container" [ngClass]="getClasses()">
        <ng-container *ngIf="rows ===0 ">
            <ng-container *ngIf="!standalone;else standaloneInput">

                <input *ngIf="!isUpperCase" class="app-input-entry"
                    [class.filled-date]="filledDate()" [type]="type"
                    [class.alwaysValid]="alwaysValid" [id]="id"
                    [name]="name ?? controlName" placeholder="Digite"
                    [maxLength]="maxLength" [attr.min]="min" [attr.max]="max"
                    [readOnly]="!!readOnly" [formControlName]="controlName"
                    [attr.pattern]="pattern"
                    [attr.autocomplete]="getAutocomplete()">

                <input *ngIf="isUpperCase" class="app-input-entry"
                    [class.filled-date]="filledDate()" [type]="type" [id]="id"
                    [name]="name ?? controlName" [placeholder]="placeholder"
                    [maxLength]="maxLength" [attr.min]="min" [attr.max]="max"
                    [readOnly]="!!readOnly" [formControlName]="controlName"
                    [attr.pattern]="pattern"
                    [attr.autocomplete]="getAutocomplete()" appUpperCase>

            </ng-container>


            <ng-template #standaloneInput>
                <input *ngIf="rows === 0" class="app-input-entry"
                    [class.filled-date]="filledDate()" [type]="type" [id]="id"
                    [name]="name ?? controlName" [placeholder]="placeholder"
                    [maxLength]="maxLength" [attr.min]="min" [attr.max]="max"
                    [readOnly]="!!readOnly" [attr.pattern]="pattern"
                    [(ngModel)]="value" [attr.autocomplete]="getAutocomplete()"
                    [ngModelOptions]="{standalone: true}"
                    (change)="handleChange($event)">
            </ng-template>
        </ng-container>

        <textarea class="app-input-entry" [id]="id" [name]="name ?? controlName"
            placeholder="Digite" [readOnly]="!!readOnly"
            [formControlName]="controlName" *ngIf="rows !== 0" [rows]="rows"
            [maxLength]="maxLength" [class.no-resize]="noResize"></textarea>

        <div *ngIf="isPassword" class="app-input-icon"
            [class.password]="isPassword">
            <button type="button" class="invisible-button"
                (click)="passwordReveal()" (mousedown)="$event.preventDefault()"
                (mouseup)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
                (touchend)="$event.stopPropagation()">
                <svg-icon src="assets/images/icon-eye.svg"
                    fill="var(--main)"
                    *ngIf="type === 'password'"></svg-icon>
                <svg-icon src="assets/images/icon-view-off.svg"
                    fill="var(--main)"
                    *ngIf="type !== 'password'"></svg-icon>
            </button>
        </div>

        <div *ngIf=" getError()" class="app-input-icon error"
            [class.mr-4]="isPassword">
            <svg-icon src="assets/images/icon-error.svg"></svg-icon>
        </div>
    </div>
    <p class="app-input-helper" *ngIf="helpText && !getError()">{{helpText}}
    </p>
    <p class="app-input-error" *ngIf="getError()">{{getErrorMessage()}}</p>
</div>